define('plugin/social-gallery/view/SocialGalleryModuleIndexView',['require','lib/view/BaseCompositeView','plugin/social-gallery/view/SocialGalleryModuleItemView','lib/view/UnwrapBehavior'],function (require) {

    var Parent = require('lib/view/BaseCompositeView');
    var SocialGalleryModuleItemView = require('plugin/social-gallery/view/SocialGalleryModuleItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Gallery composite view (images container)
     *
     * @class GalleryIndexView
     */
    return Parent.extend({

        _moduleId: 'social_gallery',

        template: '#social_gallery_module_list_view',
        childView: SocialGalleryModuleItemView,
        childViewContainer: '#sb_social_gallery_module_list_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        collectionEvents: {
            sync: 'render'
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('module', 'shown', {
                'module': 'social_gallery'
            });
        }

    });

});
